import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import OrdersSelector, { IStateProps, IDispatchProps, IOwnProps } from './OrdersSelector'
import { setSelectedDate, DashboardAction } from '../../services/store/actions/dashboard/DashboardAction'
import { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    availableDays: state.Dashboard.availableDays,
    selectedDate: state.Dashboard.selectedDate,
  }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    setSelectedDate: date => dispatch(setSelectedDate({date})),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(OrdersSelector)
